/**
 * @function readSelectedImages
 * @description Reads back the list of images selected in `ShoreSPeriodImageChooser`
 * (persisted to sessionStorage as `shoreSSelectedDates`), used by `ShoreSAnalysisSteps` to know
 * which dates to run the analysis against and by `ImageChooserCard` to render the loaded-images
 * accordion. Returns an empty array if nothing was saved yet or the value is malformed.
 * **Called by:
 * @see {ShoreSAnalysisSteps}
 * @see {ImageChooserCard}
 * @memberof module:ShoreS
 * @returns {Array<{name: string, date: string}>}
 */
export const readSelectedImages = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem('shoreSSelectedDates')) || [];
  } catch (e) {
    return [];
  }
};
